if (typeof window !== 'undefined') {
  const origCreateElement = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
  // visual-edits'in eklediği x-line-number prop'unu filtrele
  const _warn = console.error.bind(console);
  console.error = (...args) => {
    if (typeof args[0] === 'string' && args[0].includes('x-line-number')) return;
    _warn(...args);
  };
}
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import { LanguageProvider } from "@/LanguageContext";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);
